export const belgianClientDefaultName = 'N/A';
export const belgianClientDefaultAddress = 'N/A';
export const checkedBelgianClientName = 'Arts & Lux';
export const checkedBelgianClientAddress = 'Avenue des Arts 58, 1000, Brussels';

export const checkCountryIsBelgium = (countries) => {
  return !countries.includes('GR') && countries.includes('BE');
};
